export default "__VITE_ASSET__D8B_yu4H__"